// extracted by mini-css-extract-plugin
export default {"pageLayout":"Suppliers_pageLayout__fmBhQ"};